import { render, staticRenderFns } from "./MediaTab.vue?vue&type=template&id=27b05b87&scoped=true&"
import script from "./MediaTab.vue?vue&type=script&lang=ts&"
export * from "./MediaTab.vue?vue&type=script&lang=ts&"
import style0 from "./MediaTab.vue?vue&type=style&index=0&id=27b05b87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b05b87",
  null
  
)

export default component.exports